// extracted by mini-css-extract-plugin
export default {"overlay":"baseModal_overlay__ToJ7P","modalContainer":"baseModal_modalContainer__UB57c","modal":"baseModal_modal__o-gP2"};